module.exports = __webpack_public_path__ + "media/matr1x_fire_banner_pc.7f875445.mp4";